import type React from 'react';
import { CardHeader, Divider, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { fDateTime } from '../../utils/formatTime';
import type { RequestProps } from '../../models';

const dividerSx = { borderBottomWidth: 1.5 };

interface CreatedAtProps {
	id?: string | null;
	createdAt: RequestProps['createdAt'];
}

export const CreatedAt: React.FC<CreatedAtProps> = ({ id, createdAt }) => {
	if (!id || !createdAt) return null;
	return (
		<>
			<CardHeader title="ID & Submission Time" />
			<Divider sx={dividerSx} />
			<CardContent>
				<Grid container spacing={1}>
					<Grid size={{ xs: 6 }}>
						<Typography variant="body1">{id}</Typography>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<Typography variant="body1">{fDateTime(createdAt)}</Typography>
					</Grid>
				</Grid>
			</CardContent>
		</>
	);
};
